module.exports = "/build/web/svg/icon-mail.11ae4f8de532500eb6286a94cdf3a6b4.svg";


//////////////////
// WEBPACK FOOTER
// ./svg/icon-mail.svg
// module id = 141
// module chunks = 11